import React from "react";
import { Link } from "gatsby";
import g from "glamorous";
import { css } from "glamor";
import { FaEnvelope }  from "react-icons/fa";
import { FaPhone } from "react-icons/fa";
import { FaSearch } from "react-icons/fa";
import LanguageSwitcher from "./LanguageSwitcher-en";

const bounce = css.keyframes({
  "0%": { transform: "translateX(-100%)", opacity: 0.3 },
  "20%": { opacity: 0.5 },
  "100%": { transform: "translateX(0)", opacity: 1 }
});

const Nav = g.div({
  animation: `${bounce} .3s ease-out`,
  width: `100%`,
  position: `absolute`,
  top: `45px`,
  left: `0px`,
  display: `flex`,
  flexDirection: `column`,
  backgroundColor: `#3c4d68`,
  transition: `all 0.5s`,
  paddingTop: `.8em`
});

const NavItem = g.div({
  padding: `.25em 1.3em`,
  fontWeight: `500`,
  fontSize: `17px`,
  letterSpacing: `.04em`,
  "::before": {
    content: "•",
    paddingRight: `.4em`
  }
});

const NavItemRight = g.div({
  padding: `.3em 1.4em`,
  fontWeight: `500`,
  fontSize: `17px`,
  letterSpacing: `.04em`,
  textAlign: `right`
});

const Questions = g.div({
  fontSize: `13px`,
  padding: `0 1.8em 0`,
  marginTop: `10px`,
  textAlign: `right`
});

const cssLink = css({
  padding: `.3em 4em .3em .3em`
});

export default ({ children, ...props }) => (
  <Nav>
    <NavItem>
      <Link to="/en/" {...cssLink}>
        Home
      </Link>
    </NavItem>
    <NavItem>
      <Link to="/en/treatments/" {...cssLink}>
        Treatments
      </Link>
    </NavItem>
    <NavItem>
      <Link to="/en/procedures/" {...cssLink}>
        Procedures
      </Link>
    </NavItem>
    <NavItem>
      <Link to="/en/before-after/" {...cssLink}>
        Before - After
      </Link>
    </NavItem>
    <NavItem>
      <Link to="/en/plastic-surgeon-paris/" {...cssLink}>
        Qualifications
      </Link>
    </NavItem>
    <NavItem>
      <Link to="/en/plastic-surgery-practice/" {...cssLink}>
        Practice
      </Link>
    </NavItem>
    <NavItem>
      <Link to="/en/medical-team/" {...cssLink}>
        Medical team
      </Link>
    </NavItem>
    <NavItem>
      <Link to="/en/testimonials/" {...cssLink}>
        Testimonials
      </Link>
    </NavItem>
    <NavItem>
      <Link to="/en/consultations/" {...cssLink}>
        Consultations
      </Link>
    </NavItem>

    <Questions>You have a question ?</Questions>
    <NavItemRight>
      <Link to="/en/contact-us/">
        <FaEnvelope css={{ margin: `0 10px 3px 0` }} />
        Contact-us
      </Link>
    </NavItemRight>
    <NavItemRight css={{ margin: `0` }}>
      <a href="tel:+33145628500">
        <FaPhone css={{ fontSize: `20px`, margin: `0 12px 3px 0` }} />
        (+33)1 45 62 85 00
      </a>
    </NavItemRight>
    <NavItemRight css={{ margin: `0` }}>
      <Link to="/en/search/">
        <FaSearch css={{ fontSize: `20px`, margin: `0 12px 3px 0` }} />
        Search
      </Link>
    </NavItemRight>
    <NavItemRight css={{ margin: `-12px 0 1.2em` }}>
      <LanguageSwitcher pathFr={props.pathFr} />
    </NavItemRight>
  </Nav>
);
